/**
 * Created by spepa on 20.12.2022
 */

const PromotionSaleLogic = function (offer) {
    this.offer = offer;

    this.onUpdateLots = function () {};
    this.onWindowShowUpFinished = function () {};
    this.onLotPurchaseFinished = {};
};

PromotionSaleLogic.prototype.getStage = function () {
    return this.offer.stage || 0;
};

PromotionSaleLogic.prototype.getLots = function () {
    return Offers[this.offer.type].reward || RewardsConfig.PromotionSale;
};

PromotionSaleLogic.prototype.isSoldLot = function (lotId) {
    return this.getStage() > lotId;
};

PromotionSaleLogic.prototype.isDisabled = function (lotId) {
    return this.isSoldLot(lotId) || (lotId > 0 && !this.isSoldLot(lotId - 1));
};

PromotionSaleLogic.prototype.isAllSold = function () {
    return this.getLots().every((lot) => this.isSoldLot(lot.id));
};

PromotionSaleLogic.prototype.getTimeLeft = function () {
    const conf = Offers[this.offer.type];
    if (conf.feature) {
        const event = cleverapps.eventManager.getFeatureEvent(conf.feature);
        return (event && event.getTimeLeft()) || 0;
    }
    return Math.max(0, (this.offer.started || 0) + cleverapps.parseInterval(conf.duration) - Date.now());
};

PromotionSaleLogic.prototype.isIconAvailable = function () {
    return true;
};

PromotionSaleLogic.prototype.hasIconAttention = function () {
    return false;
};

PromotionSaleLogic.prototype.checkIfComplete = function () {
    if (this.isAllSold()) {
        this.offer.complete();
    }
};

PromotionSaleLogic.prototype.getProduct = function (lot) {
    return Product.CreateByHardPrice(lot.hardPrice, {
        type: "promotion_sale",
        offer: this.offer.type,
        lot: lot.id
    });
};

PromotionSaleLogic.prototype.buyLot = function (lot) {
    if (!this.isSoldLot(lot.id)) {
        const product = this.getProduct(lot);
        product.buy(this.processLotBought.bind(this, lot), { noRewardWindow: true });
    }
};

PromotionSaleLogic.prototype.processLotBought = function (lot, success) {
    if (!success) {
        if (this.onLotPurchaseFinished[lot.id]) {
            this.onLotPurchaseFinished[lot.id](false);
        }
        return;
    }

    const product = this.getProduct(lot);
    this.offer.logPurchase(product);
    
    this.offer.incStage();

    if (this.onUpdateLots) {
        this.onUpdateLots();
    }
    this.checkIfComplete();

    if (this.onLotPurchaseFinished[lot.id]) {
        this.onLotPurchaseFinished[lot.id](true);
    }
};

PromotionSaleLogic.prototype.findLot = function (lotId) {
    return this.getLots().find((lot) => lot.id === lotId);
};

PromotionSaleLogic.RestoreBoughtReward = function (context) {
    const offer = cleverapps.offerManager.findOffer({ type: context.offer });
    const lot = offer && offer.logic.findLot(context.lot);
    return lot && lot.reward;
};

Restorable.BY_TYPE["promotion_sale"] = new Restorable({
    location: Restorable.LocationOfferExpedition,
    // the goods are granted by the lot view's listener, so the window path stays until granting moves into the logic
    listActions: function (product, context, consume) {
        const offer = cleverapps.offerManager.findOffer({ type: context.offer });
        if (!offer) {
            return;
        }

        if (offer.logic.isSoldLot(context.lot)) {
            return Restorable.AlreadyOwnedActions(consume);
        }

        const lot = offer.logic.findLot(context.lot);
        if (!lot) {
            return;
        }

        return [
            function (f) {
                offer.logic.onWindowShowUpFinished = cleverapps.once(() => {
                    consume();
                    offer.logic.processLotBought(lot, true);
                });

                cleverapps.offerManager.showOfferWindow(offer);
                f();
            }
        ];
    },
    boughtReward: PromotionSaleLogic.RestoreBoughtReward
});